<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row>
							<v-col cols="12">
								<v-menu
									v-model="menu.datebegin"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
									<v-text-field v-bind="attrs" v-on="on"
										v-model="params.datebegin"
										label="Дата початку періоду"
										prepend-icon="mdi-calendar"
										readonly
										outlined
										dense
										hide-details="auto"
									></v-text-field>
									</template>
									<v-date-picker
									v-model="params.datebegin"
									@input="menu.datebegin = false"
									></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12">
								<v-menu
									v-model="menu.dateend"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
									<v-text-field v-bind="attrs" v-on="on"
										v-model="params.dateend"
										label="Дата завершення періоду"
										prepend-icon="mdi-calendar"
										readonly
										outlined
										dense
										hide-details="auto"
									></v-text-field>
									</template>
									<v-date-picker
									v-model="params.dateend"
									@input="menu.dateend = false"
									></v-date-picker>
								</v-menu>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>

		
		<v-container style="padding: 64px 0px 0px 256px;">
			<v-breadcrumbs :items="crumbs" divider="-" ></v-breadcrumbs>
		
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }}
				</v-card-title>

				<v-divider></v-divider>

				<v-data-table v-if="data.datasets.ds.length"
					:headers="headers"
					:items="data.datasets.ds"
					hide-default-footer
					disable-pagination
				></v-data-table>
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :code="code" :name="name"></z-pdf>
	</v-main>
</template>

<script>
import mixin from './mixin/main'
// import downloadExcel from "vue-json-excel"

export default {
	mixins: [mixin],
	components: { },
	data: () => ({
		headers: [
			{ text: 'Марка', value: 'BrandName' },
			{ text: 'Модель', value: 'ModelName' },
			{ text: 'Кількість', value: 'cnt' },
		],
	}),

	props: {
		code: 				{ type: String, default: 'VehicleRequestBrandModelCount' },
		name: 				{ type: String, default: 'Кількість запитів по типам і користувачам за період' },
		datebegin: 			{ type: [Date, String] },
		dateend: 			{ type: [Date, String] },
	},

	computed: {
		total() {
			const initialValue = 0;
			const sumWithInitial = this.data.datasets.ds.reduce(
				(accumulator, element) => accumulator + parseInt(element.cnt),
				initialValue,
			);

			return sumWithInitial
		}
	},
}
</script>